module.exports = __webpack_public_path__ + "static/media/hammer.3b6265b6.png";